module.exports = __webpack_public_path__ + "static/media/testimonial-guilherme.5d61f25e.jpg";